import React, { useState, useEffect } from 'react'
import { Chart as ChartJS, ArcElement, Tooltip, Legend, CategoryScale, LinearScale, PointElement, LineElement, Filler, BarElement, plugins, } from "chart.js";
import { Doughnut, Line, Bar } from "react-chartjs-2";
import TransferenciasGlobaisApi from '../../services/robinhood/TransferenciasGlobaisApi';
ChartJS.register(CategoryScale, Legend, Tooltip, ArcElement, LinearScale, PointElement, LineElement, Filler, BarElement,)

export default function TransferenciasGlobaisChartBar(props) {

    const [transferencias, setTransferencias] = useState([]);
    const labels = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
    const [chartData, setChartData] = useState([]);
    const chartColors = [
        '#13AB86', '#17D3A4', '#30E8BA', '#6EEFCF', '#C1F8EA', '#EAFDF8',
        // '#3e5f8a', '#5783bc', '#6a9cde', '#a0c5f7', '#cadffb',
        '#005227', '#038554', '#03bb85', '#68ddbd', '#a4fff7',
        '#005954', '#338b85', '#5dc1b9', '#9ce0db', '#d5ffff',
        '#d0fdd7', '#9bfab0', '#64c27b', '#2a8c4a', '#D8F0E1',
        '#b8e4ff', '#ffe4ea', '#ffe4e1', '#d0fdd7', "rgba(20, 160, 193, 0.8)",
        '#E26B64', '#6610f2', "rgba(255, 99, 132)", "rgba(2, 204, 156, 0.75)",
    ];

    useEffect(() => {
        let dadosTmp = [];
        props.anos.map((ano, i) => {
            let tmp = [];
            props.transferencias.map((transferencia) => {
                if (ano.ano == transferencia.ano) {
                    if (transferencia.transferenciaglobal_item_id == 6) {
                        tmp.push(parseFloat(transferencia.transferenciaglobal_valor));
                    }
                }
            });
            const dataModel = {
                label: ano.ano,
                data: tmp,
                borderColor: chartColors[i],
                backgroundColor: chartColors[i],
            };
            dadosTmp.push(dataModel);
        });
        setChartData(dadosTmp);
    }, [props.transferencias])

    const data = {
        labels,
        datasets: chartData,
    };

    const chartOption = {
        responsive: true,
        plugins: {
            title: {
                display: false,
                text: 'VALOR LIQUIDO',
                alight: 'left',
                padding: {
                    top: 0,
                    bottom: 0

                },


            },
        }
    }

    return (
        <>
            <div className="col-md-9" style={{ marginBottom: '' }}>
                <div className="card" >
                    <span style={{ position: 'absolute', top: '5px', left: '20px' }} className='text-muted small'>EVOLUÇÃO DAS TRANSFERÊNCIAS LÍQUIDAS</span>
                    <div className="body m-b-0" style={{ marginBottom: '', height: '142px' }}>
                        <Bar data={data} options={chartOption} height={25} />
                    </div>
                    {props.children}
                </div>
            </div>
        </>
    )
}
